import React from 'react';
import PropTypes from "prop-types";
import styles from '../NewMyPropertyTeaser.less';

const MyPropertyDescription = ({ header, text, isHomePage }) => (
  <div className={`grid-item seven-eighth palm-four-fifth grid-align-center desk-padding-left-s lap-padding-left-s ${isHomePage ? `${styles.textDescription}` : ``}`}>
    <div className={styles.myPropertyFunctionalityHeader}>{header}</div>
    <p>{text}</p>
  </div>
);

MyPropertyDescription.propTypes = {
  header: PropTypes.string,
  text: PropTypes.string,
  isHomePage: PropTypes.bool,
};

MyPropertyDescription.defaultProps = {
  isHomePage: false
};


export default MyPropertyDescription;
